import createActions from '../config/actions/createActions';
import { action } from '@play-co/replicant';
import { CardId, tradeLimits } from './cards.ruleset';
import {
  cardsAddCard,
  cardsAddCardReceived,
  cardsRemoveCard,
} from './cards.modifiers';
import { grantCardPackByTier } from '../cardpack/cardpack.modifiers';
import { CardPackTier } from '../cardpack/cardpack.ruleset';

/** Development mode only, not allowed in production */
export const cardsCheats = createActions({
  /**
   * Fully reset cards for the user
   */
  cheat_cardsReset: action((state, _: void, api) => {
    delete state.cards;
  }),

  /**
   * Add a card to the user's collection
   */
  cheat_cardsAddCard: action((state, args: { cardId: CardId }, api) => {
    cardsAddCard(state, {
      cardId: args.cardId,
      now: api.date.now(),
    });
  }),

  /**
   * Remove a card from the user's collection
   */
  cheat_cardsRemoveCard: action((state, args: { cardId: CardId }, api) => {
    cardsRemoveCard(state, {
      cardId: args.cardId,
      now: api.date.now(),
    });
  }),

  /**
   * Simulate cards received from a friend
   */
  cheat_cardsAddCardsReceived: action(
    (state, args: { cardIds: CardId[] }, api) => {
      for (const cardId of args.cardIds) {
        cardsAddCardReceived(state, {
          cardId,
          userId: 'friend',
          now: api.date.now(),
        });
      }
    },
  ),

  /**
   * Grant a cards pack by tier
   */
  cheat_cardsGrantPack: action((state, args: { tier: CardPackTier }, api) => {
    grantCardPackByTier(state, args.tier, api.date.now());
  }),

  /**
   * Reset the trades for the user
   */
  cheat_cardsResetTrades: action((state, _: void, _api) => {
    if (!state.cards) return;

    state.cards.cardTrades = {
      cardsSent: [],
      cardsReceived: [],
      tradesStartedAt: [],
      cardsDiscarded: 0,
    };
  }),

  /**
   * Fill in the daily trades for testing
   */
  cheat_cardsMaxTrades: action((state, _: void, api) => {
    if (!state.cards) return;

    const cardId: CardId = 'burumoments_beach_01';

    state.cards.cardTrades = {
      cardsSent: [
        {
          cardId,
          timestamp: api.date.now(),
        },
        {
          cardId,
          timestamp: api.date.now(),
        },
        {
          cardId,
          timestamp: api.date.now(),
        },
        {
          cardId,
          timestamp: api.date.now(),
        },
        {
          cardId,
          timestamp: api.date.now(),
        },
      ],
      cardsReceived: [
        {
          cardId,
          timestamp: api.date.now(),
        },
        {
          cardId,
          timestamp: api.date.now(),
        },
        {
          cardId,
          timestamp: api.date.now(),
        },
        {
          cardId,
          timestamp: api.date.now(),
        },
        {
          cardId,
          timestamp: api.date.now(),
        },
      ],
      tradesStartedAt: Array.from({ length: tradeLimits.trade.amount }, () =>
        api.date.now(),
      ),
      cardsDiscarded: 0,
    };
  }),
});
